import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { withNamespaces } from 'react-i18next';
import { Icon } from 'components';
import {
  Grid,
  GridItem,
  Circle,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
} from '@chakra-ui/react';
import {
  ProjectInfoTerm,
  ProjectInfoDef,
  ProjectInfoFullRow,
} from 'apps/project/views/overview.styles';

const dashboardFileInfo = {
  ecadFiles: {
    name: 'Electrical',
    color: '#0F2EFF',
    proportionName: 'ecadProportion',
  },
  mcadFiles: {
    name: 'Mechanical',
    color: '#FFFFFF',
    proportionName: 'mcadProportion',
  },
  imageFiles: {
    name: 'Images',
    color: '#FFD700',
    proportionName: 'imageProportion',
  },
  dataFiles: {
    name: 'Data',
    color: '#CFCFCF',
    proportionName: 'dataProportion',
  },
  documentFiles: {
    name: 'Documents',
    color: '#D11111',
    proportionName: 'documentProportion',
  },
  otherFiles: {
    name: 'Others',
    color: '#11D111',
    proportionName: 'otherProportion',
  },
};

const StackedPercentageBar = props => {
  const { info } = props;

  // TODO: Sort keys?
  const sortedKeys = Object.keys(info);
  let columns = '';

  const divs = [];

  sortedKeys.forEach(key => {
    if (key !== 'totalFiles') {
      const details = info[key];
      columns += `${details.count || 0}fr `;
      divs.push(
        <div
          key={`${key}-col `}
          style={{ backgroundColor: details.color }}
        ></div>,
      );
    }
  });

  return (
    <StyledPercentageBar style={{ gridTemplateColumns: columns }}>
      {divs}
    </StyledPercentageBar>
  );
};

StackedPercentageBar.propTypes = {
  info: PropTypes.object,
};

const FilesProportion = props => {
  const { app } = props;
  const { showingFilesProportion } = app;

  if (!app.fileDetails) {
    return null;
  }

  const filesInfo = app.fileDetails;

  const filesEntries = [];
  Object.keys(dashboardFileInfo).forEach(key => {
    const details = dashboardFileInfo[key];
    const percentage = parseFloat(filesInfo[details.proportionName]) * 100;
    filesEntries.push(
      <FileInfoRow key={`${key}-file-entry `}>
        <StyledCircle size='1em' bg={details.color}></StyledCircle>
        <p>
          {`${dashboardFileInfo[key].name}`}{' '}
          <span>{percentage.toFixed(1)}%</span>
        </p>
      </FileInfoRow>,
    );
  });

  // Prepare the input for the chart
  const barInput = { ...dashboardFileInfo };

  Object.keys(barInput).forEach(key => {
    const details = barInput[key];
    details.count = filesInfo[key];
  });

  barInput.totalFiles = filesInfo.totalFiles;

  return (
    <StyledFileAccordion
      allowToggle
      onChange={() => {
        app.ToggleFilesProportionDetailsView();
      }}
    >
      <AccordionItem>
        <AccordionButton>
          <ProjectInfoTerm style={{ paddingLeft: '0.5em', border: 'none' }}>
            File types{' '}
            <Icon
              name={showingFilesProportion ? 'caret_down' : 'caret_up'}
              style={{ transform: 'translateY(-0.2em)' }}
            ></Icon>
          </ProjectInfoTerm>
          <ProjectInfoDef>{''}</ProjectInfoDef>
        </AccordionButton>

        <AccordionPanel pb={4}>
          <ProjectInfoFullRow>
            <StackedPercentageBar info={barInput}></StackedPercentageBar>
            <FileListingDiv>{filesEntries}</FileListingDiv>
          </ProjectInfoFullRow>
        </AccordionPanel>
      </AccordionItem>
    </StyledFileAccordion>
  );
};

FilesProportion.propTypes = {
  app: PropTypes.object,
};

const FileListingDiv = styled(Grid)`
  grid-template-columns: repeat(2, 1fr);
  padding: ${props =>
    `${props.theme.spacing.default} 0 ${props.theme.spacing.default} ${props.theme.spacing.medium}`};
  border-bottom: 1px solid ${props => props.theme.color.wfGrey200};
  &:last-of-type {
    border-bottom: none;
  }
  border-right: 1px solid ${props => props.theme.color.wfGrey200};
  padding-bottom: 2em;
  border: none;
`;

const FileInfoRow = styled(GridItem)`
  display: inline-flex;

  p {
    margin-left: 0.5em;
    font-weight: bold;
  }

  p > span {
    font-weight: normal;
    margin-left: 0.3em;
  }
`;

const StyledCircle = styled(Circle)`
  transform: translateY(0.25em);
  border-style: solid;
  border-color: #757575;
  border-width: 1px;
`;

const StyledPercentageBar = styled.div`
  border-color: #757575;
  border-width: 1px;
  border-radius: 0.5em;
  height: 1.5em;
  display: grid;
  overflow: hidden;
  -webkit-box-shadow: 1px 6px 15px -6px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 1px 6px 15px -6px rgba(0, 0, 0, 0.75);
  box-shadow: 1px 6px 15px -6px rgba(0, 0, 0, 0.75);
`;

const StyledFileAccordion = styled(Accordion)`
  grid-row: 5;
  grid-column: 1 / span 2;
`;
export default withNamespaces()(observer(FilesProportion));
